export default {
  get_all: { method: 'get', url: 'api/legal-people?xanana' },
  show: { method: 'get', url: 'api/legal-people{/id}' },
  store: { method: 'post', url: 'api/legal-people' },
  update: { method: 'put', url: 'api/legal-people{/id}' },
  delete: { method: 'delete', url: 'api/legal-people{/id}' }
}
